import React, { useState, useEffect } from "react";
import { API_URL } from "./config"; // Ensure API_URL is imported
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import './TripCards.css'; // Import the CSS for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as solidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as regularStar } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'; // Import the back arrow icon
import DashboardLayout from './DashboardLayout/DasboardLayout';

const Feedback = () => {
  const APILINK = API_URL;
  const [feedbackData, setFeedbackData] = useState([]);
  const [rideshareFeedbackData, setRideshareFeedbackData] = useState([]);
  const [activeTab, setActiveTab] = useState('private'); // 'private' or 'rideshare'
  const navigate = useNavigate(); // Initialize useNavigate

  const getFeedback = async () => {
    try {
      const response = await fetch(`${APILINK}/trip/getlasttwentyfeedback`);
      const data = await response.json();
      console.log("Private trips feedback:", data);
      setFeedbackData(data);
    } catch (error) {
      console.log("Error fetching private trips feedback:", error);
    }
  };

  const getRideshareFeedback = async () => {
    try {
      const response = await fetch(`${APILINK}/rideshare/feedback`);
      const data = await response.json();
      console.log("Rideshare feedback:", data);
      setRideshareFeedbackData(data);
    } catch (error) {
      console.log("Error fetching rideshare feedback:", error);
    }
  };

  useEffect(() => {
    getFeedback();
    getRideshareFeedback();
    const interval = setInterval(() => {
      getFeedback();
      getRideshareFeedback();
    }, 7000);
    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <FontAwesomeIcon
          key={i}
          icon={i <= rating ? solidStar : regularStar}
          style={{ color: '#FFD700', marginRight: '4px', fontSize: '20px' }} // Adjust color and size as needed
        />
      );
    }
    return stars;
  };

  return (
    <DashboardLayout>
      <div className="hearder-feed">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#FFD700', // Golden color for the icon
              fontSize: '24px',
              marginRight: '10px' // Space between button and title
            }}
            onClick={() => navigate('/')} // Navigate back to home
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
          <h1 style={{ margin: '0 auto', textAlign: 'center', flexGrow: 1 }}>Feedbacks</h1>
        </div>

        {/* Tab Buttons */}
        <div style={{ display: 'flex', marginBottom: '20px', gap: '10px' }}>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: activeTab === 'private' ? '#FFD700' : '#6c757d',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => setActiveTab('private')}
          >
            Private Trips ({feedbackData.length})
          </button>
          <button
            style={{
              padding: '10px 20px',
              backgroundColor: activeTab === 'rideshare' ? '#FFD700' : '#6c757d',
              color: '#fff',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold'
            }}
            onClick={() => setActiveTab('rideshare')}
          >
            Rideshare ({rideshareFeedbackData.length})
          </button>
        </div>

        <div className="trip-cards-container">
          {activeTab === 'private' ? (
            // Private Trips Feedback
            feedbackData.length > 0 ? (
              feedbackData.map((trip) => (
                <div key={trip.trip_id} className="trip-card">
                  <h3>Trip ID: {trip.trip_id}  ({trip.status}) - Private Trip</h3>
                  
                  <div className="ride-info-container" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>From:</strong> {trip.origin_location || 'N/A'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>To:</strong> {trip.dest_location || 'N/A'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Ride Type:</strong> {trip.deliveray_details || 'Standard'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Distance:</strong> {trip.distance || 'N/A'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Cost:</strong> ${trip.accepted_cost || trip.delivery_cost_proposed || 'N/A'}
                    </p>
                  </div>
                  
                  <div className="comments-container">
                    <div className="comments-row">
                      <div className="comment-section">
                        <p><strong>Customer Comment</strong></p>
                        <div className="comment-card customer-comment">
                          <p>{trip.customer_comment || 'No comments'}</p>
                        </div>
                      </div>
                      <div className="comment-section">
                        <p><strong>Driver Comment</strong></p>
                        <div className="comment-card driver-comment">
                          <p>{trip.driver_comment || 'No comments'}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="stars-container">
                    <div className="stars-row">
                      <div className="rating-section">
                        <p><strong>Driver Stars</strong></p>
                        <div className="rating-display">
                          <span className="user-id">{trip.driver_id || 'N/A'}</span>
                          <span className="stars-display">{renderStars(trip.driver_stars)}</span>
                        </div>
                      </div>
                      <div className="rating-section">
                        <p><strong>Customer Stars</strong></p>
                        <div className="rating-display">
                          <span className="user-id">{trip.cust_id || 'N/A'}</span>
                          <span className="stars-display">{renderStars(trip.customer_stars !== null ? trip.customer_stars : 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No private trip feedback available.</p>
            )
          ) : (
            // Rideshare Feedback
            rideshareFeedbackData.length > 0 ? (
              rideshareFeedbackData.map((feedback) => (
                <div key={feedback.request_id} className="trip-card">
                  <h3>Request ID: {feedback.request_id} - Rideshare</h3>
                  
                  <div className="ride-info-container" style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Customer ID:</strong> {feedback.customer_id || 'N/A'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Driver ID:</strong> {feedback.driver_id || 'N/A'}
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px', color: '#2c3e50' }}>
                      <strong>Status:</strong> {feedback.status || 'N/A'}
                    </p>
                  </div>
                  
                  <div className="comments-container">
                    <div className="comments-row">
                      <div className="comment-section">
                        <p><strong>Customer Comment (about driver)</strong></p>
                        <div className="comment-card customer-comment">
                          <p>{feedback.customer_comment_for_driver || 'No comments'}</p>
                        </div>
                      </div>
                      <div className="comment-section">
                        <p><strong>Driver Comment (about customer)</strong></p>
                        <div className="comment-card driver-comment">
                          <p>{feedback.driver_comment_for_customer || 'No comments'}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="stars-container">
                    <div className="stars-row">
                      <div className="rating-section">
                        <p><strong>Customer Rating (for driver)</strong></p>
                        <div className="rating-display">
                          <span className="user-id">{feedback.customer_id || 'N/A'}</span>
                          <span className="stars-display">{renderStars(feedback.customer_rates_driver || 0)}</span>
                        </div>
                      </div>
                      <div className="rating-section">
                        <p><strong>Driver Rating (for customer)</strong></p>
                        <div className="rating-display">
                          <span className="user-id">{feedback.driver_id || 'N/A'}</span>
                          <span className="stars-display">{renderStars(feedback.driver_rates_customer || 0)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No rideshare feedback available.</p>
            )
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Feedback;